<template>
  <div>
    <NuxtLayout>
      <NuxtPage/>
      <div class="floating-chat">
        <ul>
          <li>
            <a href="tel:+9928257000" data-bs-toggle="tooltip" data-bs-placement="left" title="Phone">
              <i class="fas fa-phone-alt"></i>
            </a>
          </li>
          <li>
            <a href="https://m.me/nagase" data-bs-toggle="tooltip" data-bs-placement="left" title="Facebook Messenger">
              <i class="fab fa-facebook-messenger"></i>
            </a>
          </li>
        </ul>
      </div>
    </NuxtLayout>
  </div>
</template>

<script setup>
import 'swiper/css';
</script>
